import { gql } from "@apollo/client";

export const LIST_COUNTERPARTS_QUERY = gql`
  query listCounterpartsPaginated(
    $filter: CounterPartFilter
    $limit: Int
    $offset: Int
    $orderBy: [String]
  ) {
    listCounterpartsPaginated(filter: $filter) {
      totalCount
      results(limit: $limit, offset: $offset, orderBy: $orderBy) {
        id
        code
        remotePk
        name
        cycle {
          startDate
          endDate
          limitDate
        }
      }
    }
  }
`;

export const LIST_CLIENTS_QUERY = gql`
  query listClientsPaginated($filter: ClientFilter, $limit: Int, $offset: Int, $orderBy: [String]) {
    listClientsPaginated(filter: $filter) {
      totalCount
      results(limit: $limit, offset: $offset, orderBy: $orderBy) {
        id
        code
        remotePk
        name
        cycle {
          startDate
          endDate
          limitDate
        }
      }
    }
  }
`;
export const LIST_BOOKS_QUERY = gql`
  query listBooksPaginated($filter: BookFilter, $limit: Int, $offset: Int, $orderBy: [String]) {
    listBooksPaginated(filter: $filter) {
      totalCount
      results(limit: $limit, offset: $offset, orderBy: $orderBy) {
        id
        name
        code
        cycle {
          startDate
          endDate
          limitDate
        }
      }
    }
  }
`;

export const UPDATE_CLIENT = gql`
  mutation updateClient($input: UpdateClientInput!) {
    updateClient(input: $input) {
      client {
        id
        name
        shortName
        vatNumber
        code
        isCollective
        isPeriodic
        hasQuantityTracking
        hasQuantityTracking2
        hasCurrencyTracking
        currency {
          label
          value
        }
        reconciliation
        country {
          code
          name
        }
        counterPart {
          name
          id
          code
        }
        defaultCounterParts {
          name
          code
          id
        }
        company {
          id
        }
        vat {
          id
          rate
          code
        }
        isActive
        email
        phone1
        phone2
        fax
        address1
        address2
        address3
        postalCode
        city
      }
      errors {
        field
        messages
      }
    }
  }
`;

export const CREATE_CLIENT = gql`
  mutation createClient($input: CreateClientInput!) {
    createClient(input: $input) {
      client {
        id
        name
        shortName
        vatNumber
        code
        isCollective
        isPeriodic
        hasQuantityTracking
        hasQuantityTracking2
        hasCurrencyTracking
        currency {
          label
          value
        }
        reconciliation
        country {
          code
          name
        }
        counterPart {
          id
          name
          code
        }
        defaultCounterParts {
          id
          name
          code
        }
        company {
          id
        }
        vat {
          id
          rate
          code
        }
        isActive
      }
      errors {
        field
        messages
      }
    }
  }
`;
